<template>
  <modal
    class="organisation-guide-modal"
    :class="{ 'organisation-guide-modal--no-footer': !isConfirmable }"
    name="organisation-guide-modal"
    @before-open="handleBeforeOpen"
    @closed="handleClosed"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="60%"
    height="90%"
    style="z-index: 4066;"
  >
    <div id="modal-header">
      <div class="w-75 d-flex">
        <p>{{ title }}</p>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 25%"
              @click="$modal.hide('organisation-guide-modal')" aria-label="Close">
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ABAEB8"/>
        </svg>
      </button>
    </div>
    <div id="modal-body">
      <div class="detail-content">
        <div class="row h-100 mx-0">
          <div class="col-12">
            <div v-if="loading" class="d-flex justify-content-center align-items-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Բեռնվում է...</span>
              </div>
            </div>
            <div v-else class="ameria-guide guide-content" v-html="content"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isConfirmable" id="modal-footer">
      <button @click="confirm" class="btn btn-primary mr-3">
        <span>Ծանոթացել եմ</span>
      </button>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'OrganisationGuideModal',
  data() {
    return {
      title: '',
      content: '',
      isConfirmable: false,
      confirmed: false,
      loading: false,
    }
  },
  methods: {
    handleBeforeOpen({ params }) {
      this.title = params?.title || '';
      this.content = params?.content || '';
      this.isConfirmable = Boolean(params?.isConfirmable);
      this.confirmed = false;
      this.loading = false;

      const brandCode = params?.brandCode || params?.orgCode;
      const shouldFetch = (!this.content || params?.fetchFromApi) && brandCode;

      if (shouldFetch) {
        this.loading = true;
        this.$client.get(`tender/branded/${brandCode}/how-to-participate`)
          .then(({ data }) => {
            if (data) {
              if (data.title && !this.title) {
                this.title = data.title;
              }
              this.content = data.content || '';
            }
          })
          .catch((err) => {
            console.error('Failed to load guide content', err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    confirm() {
      this.confirmed = true;
      this.$modal.hide('organisation-guide-modal');
    },
    handleClosed() {
      this.$emit('closed', { confirmed: this.confirmed, isConfirmable: this.isConfirmable });
      this.title = '';
      this.content = '';
      this.isConfirmable = false;
      this.confirmed = false;
      this.loading = false;
    }
  }
}
</script>

<style scoped>
/* No confirm footer (plain informational guide, e.g. "Ինչպես մասնակցել") —
   let the body use the full modal height instead of leaving a gap where
   the footer would otherwise have been. */
.organisation-guide-modal--no-footer /deep/ #modal-body {
  height: calc(100% - 56px);
  overflow-y: auto;
}
.guide-content {
  font-size: 14px;
  line-height: 22px;
  color: #2D3036;
}
.guide-content /deep/ h1 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
}
.guide-content /deep/ h2 {
  font-size: 16px;
  font-weight: 600;
  margin-top: 16px;
  margin-bottom: 8px;
}
.guide-content /deep/ h3 {
  font-size: 14px;
  font-weight: 600;
  margin-top: 12px;
  margin-bottom: 6px;
}
.guide-content /deep/ p {
  margin-bottom: 10px;
  line-height: 1.6;
}
.guide-content /deep/ ul {
  padding-left: 20px;
  margin-bottom: 10px;
}
.guide-content /deep/ li {
  margin-bottom: 4px;
}
</style>
